import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { subscribers: { getSubscibers, } } = apiUrls;

export const SUBSCRIBERS_SUCCESS = 'SUBSCRIBERS_SUCCESS';
export const SUBSCRIBERS_LOADING = 'SUBSCRIBERS_LOADING';


export const getSubscribersData = () => async (dispatch) => {
        try {
            const { url } = getSubscibers
            const requestData = {
                ...getSubscibers, url
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: SUBSCRIBERS_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: SUBSCRIBERS_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: SUBSCRIBERS_LOADING,
        isLoading
    })
}
